import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core';
import DeveloperPage from '../../styles/templates/DeveloperPage';
import ProfileTab from './Tabs/Profile';
import PasswordResetTab from './Tabs/PasswordReset';
import CompanyTab from './Tabs/Company';
import Paper from '../../styles/templates/Paper';
import { DSTheme } from '../../styles/themes/types';
import PageHeader from '../../styles/templates/PageHeader';

interface ProfilePageProps {
  path?: string;
  default?: boolean;
}

const useStyles = makeStyles((theme: DSTheme) => ({
  tabs: {
    display: 'flex',
    flexDirection: 'row',
    widthTop: '40px',

    '& > *': {
      '&:not(:last-child)': {
        marginRight: '8px',
      },

      cursor: 'pointer',

      textAlign: 'center',
      borderRadius: '16px',
      padding: '8px 24px',
      border: '1px solid',
      borderColor: theme.palette.grey[600],
      color: theme.palette.grey[600],

      '&.selected': {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: 0,
      },
    },
  },
}));

const profileTabs: string[] = ['Profile', 'Company', 'Password Reset'];

const getTabComponent = (tab: string) => {
  switch (tab) {
    case 'Profile':
      return <ProfileTab />;
    case 'Company':
      return <CompanyTab />;
    case 'Password Reset':
      return <PasswordResetTab />;
  }
};

const ProfilePage: React.FC<ProfilePageProps> = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState('Profile');

  const onTabClick = (tab: string) => setSelectedTab(tab);
  const currentTab = getTabComponent(selectedTab);

  return (
    <DeveloperPage>
      <PageHeader title="My Personal Data" subtitle="Settings & Profile" />

      <Paper>
        <Typography variant="subtitle1">Account Settings</Typography>

        <div className={classes.tabs}>
          {profileTabs.map((tab) => (
            <div
              key={tab}
              role="tab"
              onClick={() => onTabClick(tab)}
              className={`${tab === selectedTab ? 'selected' : ''}`}
            >
              <Typography>
                <b>{tab}</b>
              </Typography>
            </div>
          ))}
        </div>
      </Paper>

      {currentTab}
    </DeveloperPage>
  );
};

export default ProfilePage;
